import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // @warn Don't modify this carefully cleaned up integration snippet from
//  https://developers.intercom.com/installing-intercom/docs/basic-javascript unless absolutely necessary!
// @note The original snippet has been completely refactored to allow lazy loading instead of having to contain
//  hard-coded app ID.
// region Install


var _window = window,
    _Intercom = _window.Intercom;

if (typeof _Intercom === 'function') {
  _Intercom('reattach_activator');

  _Intercom('update', window.intercomSettings);
} else {
  _Intercom = function Intercom() {
    _Intercom.c(arguments);
  };

  _Intercom.q = [];

  _Intercom.c = function (args) {
    _Intercom.q.push(args);
  };

  window.Intercom = _Intercom;
}

export var loadIntercom = function loadIntercom(appId) {
  return new _Promise(function (resolve, reject) {
    var loadScript = function loadScript() {
      var scriptNode = _Object$assign(document.createElement('script'), {
        type: 'text/javascript',
        async: true,
        src: "https://widget.intercom.io/widget/".concat(appId),
        onload: function onload() {
          return resolve(_Intercom);
        },
        onerror: reject
      });

      var refNode = document.getElementsByTagName('script')[0];
      refNode.parentNode.insertBefore(scriptNode, refNode);
    };

    if (document.readyState === 'complete') {
      loadScript();
    } else if (window.attachEvent) {
      window.attachEvent('onload', loadScript);
    } else {
      window.addEventListener('load', loadScript, false);
    }
  });
}; // endregion
// The wrappers below are added just as a convenience feature, as the real API is a bit unwieldy.
// region API Wrapper

export var isIntercomLoaded = function isIntercomLoaded() {
  return Boolean(_Intercom.booted);
};
export function startIntercom(appId) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _Intercom('boot', _objectSpread({}, settings, {
    app_id: appId
  }));
}
export function getIntercomSettings() {
  return window.intercomSettings;
}
export function updateIntercom() {
  var settingsUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _Intercom('update', settingsUpdate);
}
export function stopIntercom() {
  _Intercom('shutdown');
}
export function showIntercom() {
  _Intercom('show');
}
export function hideIntercom() {
  _Intercom('hide');
}
export function startIntercomTour(tourId) {
  _Intercom('startTour', tourId);
} // endregion